module.exports = __webpack_public_path__ + "images/category_lp/fishing_gear/store_images/3_314187179ce60e4cdf170f9a82487c5a.png";